// extracted by mini-css-extract-plugin
export var wrappedEllipsisText = "wrapped-ellipsis-text_VtuaEecCTAI5kmKp9jWo";